import React from 'react';

const PlayerLayout = ({ children }) => (
  <div style={{ padding: '24px 0' }}>
    {children}
  </div>
);

export default PlayerLayout;
